import Arrow from './svg-icons/Arrow';
import Attachment from './svg-icons/Attachment';
import Burger from './svg-icons/Burger';
import Close from './svg-icons/Close';
import DeleteSVG from './svg-icons/DeleteSVG';
import DoubleForward from './svg-icons/DoubleForward';
import Expand from './svg-icons/Expand';
import ForwarSvg from './svg-icons/ForwarSvg';
import NoMail from './svg-icons/NoMail';
import PlusSVG from './svg-icons/PlusSvg';
import PreForward from './svg-icons/PreForward';
import RefreshSVG from './svg-icons/RefreshSvg';
import StarSvg from './svg-icons/StarSvg';
import Collapse from './svg-icons/Collapse';
import Template from './svg-icons/Template';
import Signature from './svg-icons/Signature';
import download from './svg-icons/download';
import upload from './svg-icons/upload';
import Mail from './svg-icons/Mail';
import Flag from './svg-icons/Flag';
import FilledFlag from './svg-icons/FilledFlag';
import More from './svg-icons/More';
import ChevronUp from './svg-icons/ChevronUp';
import SentArrow from './svg-icons/SentArrow';
const svgMap = {
  plus: PlusSVG,
  burger: Burger,
  refresh: RefreshSVG,
  attachment: Attachment,
  forward: ForwarSvg,
  doubleForward: DoubleForward,
  preForward: PreForward,
  star: StarSvg,
  delete: DeleteSVG,
  close: Close,
  noMail: NoMail,
  expand: Expand,
  arrow: Arrow,
  collapse: Collapse,
  template: Template,
  signature: Signature,
  download: download,
  upload: upload,
  mail: Mail,
  flag: Flag,
  filledFlag: FilledFlag,
  more: More,
  chevronUp: ChevronUp,
  sentArrow: SentArrow,
};
export const IconWrapper = ({
  icon,
  className = '',
  color = 'currentColor',
  ...props
}) => {
  const Svg = svgMap[icon];
  if (!Svg) return null;

  return (
    <Svg
      {...props}
      className={className}
      // stroke={props.stroke ?? color}
      fill={props.fill ?? 'none'}
      color={color}
    />
  );
};
